module.exports = __webpack_public_path__ + "static/media/placas (3).4a4f083b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (3).jpg
// module id = 353
// module chunks = 0